import React, { useImperativeHandle, useRef, forwardRef } from "react";
import { Button } from "antd";
import SignatureCanvas from 'react-signature-canvas';
import { ReloadOutlined } from "@ant-design/icons";

const SignaturePad = forwardRef((props, ref) => {
    const signCanvas = useRef({});

    const clear = () => {
        signCanvas.current.clear();
    };

    useImperativeHandle(ref, () => ({
        getSignature: () => signCanvas.current.getTrimmedCanvas().toDataURL('image/png'),
        isEmpty: () => signCanvas.current.isEmpty(),
        clear: () => signCanvas.current.clear(),
    }));


    return (

        <div className="border-black border rounded-lg bg-gray-300 relative">
            <SignatureCanvas
                ref={signCanvas}
                penColor="black"
                canvasProps={{ width: 500, height: 200, className: 'sigCanvas' }}
            />

            <Button onClick={clear} className="absolute right-2 top-2" type="text"><ReloadOutlined /></Button>
        </div>
    )
});

export default SignaturePad;
